import {
  MRMS_GETTERS_ENUM,
} from './mrms.enum';

export const mrmsGetters = {
  [MRMS_GETTERS_ENUM.GET_MRMS_METADATA](state) {
    return state.rasterMetaData;
  },
};
